import { Injectable } from "@angular/core";
import { MCFieldSchema, MCPropertyValue, MCSectionSchema } from "@maslul/common-services";

@Injectable({ providedIn: 'root' })
export class SchemaService {

    //לא בתוך טבלה
    updateFielsSchema(sectionsSchema: MCSectionSchema[], fieldName: string, propertiesValueToUpdate: MCPropertyValue[]) {

        sectionsSchema.forEach((sectionSchema: MCSectionSchema) => {
            sectionSchema.fieldsSchema.forEach((fieldShchema: MCFieldSchema) => {
                if (fieldShchema.name === fieldName) {
                    propertiesValueToUpdate.forEach((prop: MCPropertyValue) => {
                        fieldShchema[prop.propertyName] = prop.value;
                    })
                }
            })
        });
    }
}